module.exports = __webpack_public_path__ + "img/16.6d3554f2.jpg";